import React from "react";
import { object, func } from "prop-types";
import Col from "../grid/Col";
import Row from "../grid/Row";
import Button from "../button/Button";
import "./DonorCard.css";

const DonorCard = ({ donor, onDelete, onEdit }) => {
	return (
		<div>
			<Col _bottom-24 donnor-card>
				<Col _bottom-4>
					<h2>{donor.name}</h2>
					<div className="secondary">{donor.description}</div>
				</Col>

				{/* <div className="divider" /> */}
				<Row card-content>
					<Col _bottom-8>
						<Col _bottom-4>
							<div className="key">phone</div>
							<div className="value">{donor.phone}</div>
						</Col>

						<Col _bottom-4>
							<div className="key">email</div>
							<div className="value">{donor.email}</div>
						</Col>
					</Col>

					<Col _bottom-8>
						<Col _bottom-4>
							<div className="key">Contact Person</div>
							<div className="value">{donor.contact_person}</div>
						</Col>

						<Col _bottom-4>
							<div className="key">Contact Person Phone</div>
							<div className="value">{donor.contact_person_phone}</div>
						</Col>
					</Col>

					<Col _bottom-8>
						<Col _bottom-4>
							<div className="key">Responsible Person</div>
							<div className="value">{donor.responsible_person}</div>
						</Col>

						<Col _bottom-4>
							<div className="key">Responsible Person Phone</div>
							<div className="value">{donor.responsible_person_phone}</div>
						</Col>
					</Col>
				</Row>
				{/* <div className="divider" /> */}

				<Row _no-grow _gap-16 _flex-end>
					{onEdit && (
						<Button onClick={e => onEdit(donor.id, e)} className={"btn-plain"}>
							EDIT
						</Button>
					)}
					{onDelete && (
						<Button
							onClick={e => onDelete(donor.id, e)}
							className={"btn-plain btn-red-text"}
						>
							DELETE
						</Button>
					)}
				</Row>
			</Col>
		</div>
	);
};

DonorCard.propTypes = {
	onDelete: func,
	onEdit: func,
	donor: object
};

export default DonorCard;



// WEBPACK FOOTER //
// ./src/common/donorCard/DonorCard.js